<template>
  <div class="link-container">
    <img :src="logo" alt="Link's logo" class="logo" />
    <a :href="link"><slot>Site</slot></a>
  </div>
</template>

<script>
export default {
  name: 'site',
  props: {
    logo: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.link-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  height: 110px;
  min-height: 90px;
}

.logo {
  width: auto;
  height: 100px;
  margin: 10px 20px;
}

a, a:visited, a:hover, a:active {
  backface-visibility: hidden;
  position: relative;
  transition: 0.5s color ease;
  text-decoration: none;
  color: white;
  font-size: 5em;
  font-weight: 900;
  text-shadow: 2px 2px black;
}

a:hover {
  color: #ff3444;
}

a:before,a:after{
  content: "";
  transition: 0.5s all ease;
  backface-visibility: hidden;
  position: absolute;
  height: 5px;
  height: 0.35rem;
  width: 0;
  background: #ff3444;
  left: 50%;
  transform: translateX(-50%);
}

a:before{
  top: 0em;
}

a:after{
  bottom: 0em;
}

a:hover:before,a:hover:after{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Site.vue?3825592e